module.exports = __webpack_public_path__ + "static/media/profile-settings.bb9d337a.svg";